import { INavigationContext } from 'framework/context/INavigationContext';
import React from 'react';
import { ProductCatalogItemDetailTabType } from '../detail/ProductCatalogItemDetailTabType';

export const NavigationContext = React.createContext<INavigationContext<ProductCatalogItemDetailTabType>>(undefined as any);
